import React, { createContext, useContext, useMemo } from 'react';
import { type BIEvents, createEvents } from './events/events';
import { type PageName } from './events/consts';

const BIContext = createContext<BIEvents | null>(null);

interface BIProviderProps {
    readonly pageName: PageName;
    readonly children: React.ReactNode;
}

export const BIProvider = ({ pageName, children }: BIProviderProps) => {
    const events = useMemo<BIEvents>(() => createEvents(pageName), [pageName]);

    return <BIContext.Provider value={events}>{children}</BIContext.Provider>;
};

export const useBI = (): BIEvents => {
    const bi = useContext(BIContext);
    if (!bi) {
        throw new TypeError('"useBI" must be used inside "BIProvider" root component');
    }
    return bi;
};
